import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from 'components/Layout/Toolbar';
import Snackbar from 'components/Shared/Snackbar';
import { WithStyles } from 'decorators/withStyles';
import { IManual } from 'interfaces/manual';
import React, { Fragment } from 'react';
import RxOp from 'rxjs-operators';
import manualService from 'services/manual';
import DocumentFileReader from 'components/Shared/FileSelector/FileReader';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import CardHeader from '@material-ui/core/CardHeader';
import { IStateList, ListComponent, TableCellSortable } from 'components/Abstract/List';
import { IPaginationParams } from 'interfaces/pagination';
import ListItem from './ListItem';
import RefreshIcon from 'mdi-react/RefreshIcon';
import IconButton from '@material-ui/core/IconButton';

interface IProps {
  classes?: any;
}

@WithStyles((theme) => ({
  input: {
    display: 'none',
  },
  dropZone: {
    width: '100%'
  },
  headTitleTable: {
    color: theme.palette.primary.main,
    fontSize: theme.spacing(2),
  },
  title: {
    fontWeight: 700
  }
}))

export default class DocumentManagement extends ListComponent<IProps, IStateList<IManual>> {
  constructor(props: {}) {
    super(props, 'createdDate', 'desc');
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = (params: Partial<IPaginationParams> = {}) => {
    this.setState({ loading: true, error: null });

    manualService.list(this.mergeParams(params)).pipe(
      RxOp.logError(),
      RxOp.bindComponent(this)
    ).subscribe(items => {
      this.setPaginatedData(items);
    }, error => this.setError(error));
  }

  onClickRefresh = () => this.loadData();

  handleManualChange = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    manualService.save(formData).pipe(
      RxOp.logError(),
      RxOp.bindComponent(this),
      RxOp.filter(res => (res && res.response))
    ).subscribe(res => {
      Snackbar.show(' Arquivo foi salvo com sucesso!');
      this.loadData();
    }, err => {
      Snackbar.error(`${err.message}`);
    });
  }

  handleManualRemove = (id: number) => () => {
    manualService.delete(id).subscribe(() => {
      Snackbar.show(' Arquivo removido com sucesso!');
      this.setState({});
    });
  }

  render() {
    const { items, loading } = this.state;
    const { classes } = this.props;

    return (
      <Fragment>
        <Toolbar title='Configurações' breadcrumbs={[{ title: 'Configurações' }, { title: 'Adicionar Documento' }]} />
        <Container>
          <Card>
            <CardHeader classes={{ title: classes.title }} title='Adicionar documento' />
            <CardContent>
              <Grid container>
                <Grid item xs={12}>
                  <div className={classes.dropZone}>
                    <DocumentFileReader droppable fileSelected={this.handleManualChange} />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCellSortable {...this.sortableProps} column='filename'>
                            Arquivo
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='createdDate' align='right'>
                            Data do upload
                          </TableCellSortable>
                          <TableCell>
                            <IconButton disabled={loading} size="small" onClick={this.onClickRefresh}>
                              <RefreshIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.renderEmptyAndErrorMessages(3)}
                        {(!loading && items) && items.map(manual => (
                          <ListItem key={`manual-item-${manual.id}`} handleRemove={this.handleManualRemove(manual.id)} manual={manual} />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {this.renderTablePagination()}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </Fragment>
    );
  }
}